import React from 'react'
import { CHECKOUT2_CUSTOMER_FORMDATA, CHECKOUT2_CUSTOMER_FORMDATA_CLEAR } from '../../constantTypes/checkout2/customerConstantTypes';

const initialCustomer={
    customer:{
    firstname:'',
    lastname:'',
    email:'',
    phone:'',
    height:'',
    iamalsoaparticipant:true
    }
}

export const CustomerReducer=(state=initialCustomer,action)=> {
    switch (action.type) {
        case CHECKOUT2_CUSTOMER_FORMDATA:
            let payload=action.payload;
            if(payload!==undefined){
              
                return{
                
                    ...state,customer:action.payload
                                }
            }else{
                return{
                
                    ...state,customer:initialCustomer
                                }
            }
            case CHECKOUT2_CUSTOMER_FORMDATA_CLEAR:
                return{
                    ...state=initialCustomer,
                    }
        default:return state;
    }
}


